export default __webpack_public_path__ + "4bbae9c7847b63266a6b81cf0277c954.webp";